import { render } from "./Notfound.vue?vue&type=template&id=32ef2cea"
import script from "./Notfound.vue?vue&type=script&lang=js"
export * from "./Notfound.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mad/Business/156kr/Clients/ archive/kultursommer/kultursommer_web25/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__